
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { getImageURL, getDisplayOrderNumber } from '@/utils/getters';
import FullPageSpinner from '@/components/shared/suites/FullPageSpinner.vue';
import Toast from '@/utils/toast';

@Component<OrdersStatusScreen>({
	components: {
		FullPageSpinner
	}
})
export default class OrdersStatusScreen extends Vue {
	@Action('fetchOrdersForCustomerDisplay', { namespace: 'orders' }) private fetchOrdersForCustomerDisplay!: () => Promise<Record<string, string[]>>;
	@Getter('getRestaurant', { namespace: 'auth' }) private restaurant!: Restaurant;

	private intervalId: number = 0;
	private isLoading: boolean = true;
	private orderIds: Record<string, string[]> = {
		pending: [],
		inProgress: [],
		completed: []
	};

	private get imageURL(): string {
		return this.restaurant.image ? getImageURL(this.restaurant.image) : '';
	}

	private created(): void {
		this.fetchOrders();
		this.setFetchInterval();
	}

	private beforeDestroy(): void {
		clearInterval(this.intervalId);
	}

	/**
	 * Set interval to fetch orders every 10 seconds
	 *
	 * @return {void}
	 */
	private setFetchInterval(): void {
		this.intervalId = window.setInterval(() => {
			this.fetchOrders();
		}, 10000);
	}

	/**
	 * Fetch the orders, categorized by their status.
	 *
	 * @return {Promise<void>}
	 */
	private async fetchOrders(): Promise<void> {
		try {
			this.orderIds = await this.fetchOrdersForCustomerDisplay();
		}
		catch (errorMessage) {
			Toast.error(this.$t('orders.management.error_fetching_orders', { errorMessage }));
		}
		finally {
			this.isLoading = false;
		}
	}

	/**
	 * Get the order number to display, prefixed with the restaurant's internal identifier.
	 *
	 * @param {string} orderId
	 * @return {string}
	 */
	private getOrderNumber(orderId: string): string {
		return getDisplayOrderNumber(orderId);
	}
}
